import clsx from 'clsx';
import React from 'react';
import { getConfigProperty } from '@/common/oldMobile';
import RedactorProfileIcon from '@/icons/RedactorProfileIcon';

function Avatar({ avatarId, redactor, className, alt = 'avatar', ...rest }) {
    const staticContentUrl = getConfigProperty('static.url');
    return redactor ? (
        <RedactorProfileIcon className="avatar" />
    ) : (
        <img
            className={clsx('avatar', className)}
            src={`${staticContentUrl}/asset/avatar/${avatarId}.png`}
            alt={alt}
            {...rest}
        />
    );
}

export default Avatar;
